<div fxFlex fxLayoutAlign="center center" fxLayout="column">
  <app-loader></app-loader>
  <div  class="mat-elevation-z16"  style="width: 98vw; height: 84vh;">
    <iframe width="100%" height="100%" [src]="reportUrl" frameborder="1" style="border:1" allowfullscreen></iframe>
  </div>
</div>